import { render, staticRenderFns } from "./TempConfigSubMajorModal.vue?vue&type=template&id=484fb659&scoped=true"
import script from "./TempConfigSubMajorModal.vue?vue&type=script&lang=js"
export * from "./TempConfigSubMajorModal.vue?vue&type=script&lang=js"
import style0 from "./TempConfigSubMajorModal.vue?vue&type=style&index=0&id=484fb659&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fb659",
  null
  
)

export default component.exports